import {Caregiver, Patient} from '@drl/shared/models';
import {PrescriptionMedicines} from './prescription-medicines.model';

export class MedicineLog {
  id: number;
  userId: number;
  takenTime: Date;
  timeToTake: Date;
  status: number;
  comment: string;
  patientId: number;
  medicineId: number;
  caregiver: Caregiver;
  patient: Patient;
  prescriptionMedicines: PrescriptionMedicines;
  others?: MedicineLog[] = [];
  svg?: string;
  day?: number;
}

export class Medicine {
  id: number;
  name: string;
  description: string;
  duration: string;
  dosage: string;
  frequency: string;
  startDate: Date;
  route: string;
}